import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Backdrop/backdrop';
import { canUseDOM } from '../../helpers';
import { KEY_CODES } from '../../helpers/constants';
import { AboutModalContainer } from './AboutModalContainer';
export var AboutModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AboutModal, _React$Component);

  function AboutModal(props) {
    var _this;

    _classCallCheck(this, AboutModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AboutModal).call(this, props));
    _this.id = AboutModal.currentId++;
    _this.ariaLabelledBy = "pf-about-modal-title-".concat(_this.id);
    _this.ariaDescribedBy = "pf-about-modal-content-".concat(_this.id);

    _this.handleEscKeyClick = function (event) {
      if (event.keyCode === KEY_CODES.ESCAPE_KEY && _this.props.isOpen) {
        _this.props.onClose();
      }
    };

    _this.toggleSiblingsFromScreenReaders = function (hide) {
      var appendTo = _this.props.appendTo;

      var target = _this.getElement(appendTo);

      var bodyChildren = target.children;

      for (var _i = 0, _Array$from = Array.from(bodyChildren); _i < _Array$from.length; _i++) {
        var child = _Array$from[_i];

        if (child !== _this.state.container) {
          hide ? child.setAttribute('aria-hidden', '' + hide) : child.removeAttribute('aria-hidden');
        }
      }
    };

    _this.getElement = function (appendTo) {
      if (typeof appendTo === 'function') {
        return appendTo();
      }

      return appendTo || document.body;
    };

    _this.state = {
      container: undefined
    };

    if (props.brandImageSrc && !props.brandImageAlt) {
      // eslint-disable-next-line no-console
      console.error('AboutModal:', 'brandImageAlt is required when a brandImageSrc is specified');
    }

    return _this;
  }

  _createClass(AboutModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var container = document.createElement('div');
      var target = this.getElement(this.props.appendTo);
      this.setState({
        container: container
      });
      target.appendChild(container);
      target.addEventListener('keydown', this.handleEscKeyClick, false);

      if (this.props.isOpen) {
        target.classList.add(css(styles.backdropOpen));
      } else {
        target.classList.remove(css(styles.backdropOpen));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var target = this.getElement(this.props.appendTo);

      if (this.props.isOpen) {
        target.classList.add(css(styles.backdropOpen));
        this.toggleSiblingsFromScreenReaders(true);
      } else {
        target.classList.remove(css(styles.backdropOpen));
        this.toggleSiblingsFromScreenReaders(false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = this.getElement(this.props.appendTo);

      if (this.state.container) {
        target.removeChild(this.state.container);
      }

      target.removeEventListener('keydown', this.handleEscKeyClick, false);
      target.classList.remove(css(styles.backdropOpen));
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          appendTo = _a.appendTo,
          props = __rest(_a, ["appendTo"]);

      var container = this.state.container;

      if (!canUseDOM || !container) {
        return null;
      }

      return ReactDOM.createPortal(React.createElement(AboutModalContainer, Object.assign({
        aboutModalBoxHeaderId: this.ariaLabelledBy,
        aboutModalBoxContentId: this.ariaDescribedBy
      }, props)), container);
    }
  }]);

  return AboutModal;
}(React.Component);
AboutModal.currentId = 0;
AboutModal.defaultProps = {
  className: '',
  isOpen: false,
  onClose: function onClose() {
    return undefined;
  },
  productName: '',
  trademark: '',
  backgroundImageSrc: '',
  noAboutModalBoxContentContainer: false,
  appendTo: null
};